import { IApplicationState } from '../../../types/redux';

export function getExpertViewData(state: IApplicationState) {
  return state.expertView;
}
